export default function () {
  if (
    document.querySelector('.CtaArticleWrapper--cta') &&
    document.querySelector(
      '.CtaArticleWrapper--cta .GeneralCtaArticleButtonWrapper a'
    )
  ) {
    import(/* webpackChunkName: "cta-track-module" */ './cta-track').then(
      (module) => {
        const CTATrack = module.default
        CTATrack()
      }
    )
  }
}
